<template>
    <v-col
        :cols="width"
        v-if="!item.props.hidden"
    >
        <v-text-field
            :append-icon="appendIcon"
            :class="alignClass"
            :hint="item.props.hint"
            :label="item.props.label"
            :name="item.name"
            :outlined="item.props.outlined !== false"
            :persistent-hint="item.props.hint ? true : false"
            :placeholder="item.props.placeholder"
            :prepend-inner-icon="prependIcon"
            :readonly="readonly || item.props.readonly"
            :rules="rules"
            :counter="!!item.props.maxLength && !['number','dollars','percent','hundredth','decimal','integer','year','ein','sos','phone'].includes(item.props.format)"
            :maxlength="item.props.maxLength"
            :value="modelValue"
            :type="item.props.format == 'url' ? 'url' : 'text'"
            ref="input"
            @change="handleChange"
            @focus="handleFocus"
        >
            <!-- <v-icon slot="prependIcon" small color="primary">{{ prependIcon }}</v-icon> -->
            <template v-slot:message="{ message }">
                <span v-html="message" @click="tabChange"></span>
            </template>

            <template v-if="alert || item.props.alert" v-slot:append>
                <v-tooltip
                    top
                    max-width="620"
                >
                    <template v-slot:activator="{ on }">
                        <v-icon v-on="on" class="warning--text">mdi-alert</v-icon>
                    </template>
                    <div v-html="alert || item.props.alert"></div>
                </v-tooltip>
            </template>
            
            <template v-else-if="item.props.tooltip" v-slot:append-outer>
                <v-tooltip
                    top
                    max-width="620"
                >
                    <template v-slot:activator="{ on }">
                        <v-icon v-on="on">mdi-information</v-icon>
                    </template>
                    <div class="py-1" v-html="item.props.tooltip"></div>
                </v-tooltip>
            </template>
        </v-text-field>
    </v-col>
</template>
<script>
    import axios from "axios";
    import Cookie from 'js-cookie'
    import appUrls from '../../helpers/environment'

    export default {
        name: 'TextField',
        props: {
            item: {
                type: Object,
                default: () => ({
                    props: {}
                })
            },
            value: {
                type: [String, Number]
            },
            readonly: {
                type: Boolean
            },
            rules: {
                type: Array,
                default: () => {[]}
            },
            alert: {
                type: [String, Object]
            },
            width: {
                type: [String, Number]
            },
            handleTabChange: {
                type: Function
            }
        },
        computed: {
            modelValue: function() {
                if (this.isFocus) {
                    return this.value;
                } else {
                    return this.formatValue(this.value)
                }
            },
            appendIcon: function () {
                switch (this.item.props.format) {
                case 'percent':
                    return 'mdi-percent';
                case 'multiples':
                    return 'mdi-file-excel-box-outline'; // mdi-alpha-x // mdi-alpha-x-box-outline // mdi-file-excel-box-outline // mdi-alpha-x-circle-outline // mdi-close-box-outline // mdi-close-thick
                default:
                    return this.item.props.appendIcon
                }
            },
            prependIcon: function () {
                switch (this.item.props.format) {
                case 'dollars':
                    return 'mdi-currency-usd';
                default:
                    return this.item.props.prependIcon
                }
            },
            alignClass: function () {
                switch ( this.item.props.format) {
                case 'dollars':
                case 'percent':
                case 'number':
                case 'hundredth':
                case 'decimal':
                case 'multiples':
                    return 'input-align-right';
                default:
                    return '';
                }
            }
        },
        data: function () {
            return {
                cursorLocation: 0,
                isFocus: false
            };
        },
        methods: {
            validate: function () {
                return this.$refs.input && this.$refs.input.validate();
            },
            handleInput: function (e) {
                const el = this.$refs.input.$el.getElementsByTagName('input')[0];

                this.$nextTick(() => {
                    el.setSelectionRange(this.cursorLocation, this.cursorLocation);
                });
            },
            formatValue: function (value = '') {
                const { props } = this.item;
                const { format } = props;

                if (value === null || value === undefined) {
                    return undefined;
                }

                switch(format) {
                    case 'phone': {
                        return value.replace(/^([0-9]{3})([0-9]{3})([0-9]{4})(.+)?$/, '($1) $2-$3');
                    }
                    case 'ein': {
                        return value.replace(/^([0-9]{2})([0-9]{7})(.+)?$/, '$1-$2');
                    }
                    case 'sos': {
                        return value.replace(/^([0-9]{3})([0-9]{2})([0-9]{4})(.+)?$/, '$1-$2-$3');
                    }
                    case 'dollars': {
                        if (value === '') {
                            return value;
                        }
                        
                        const splits = value.toString().split('.');
                        
                        if (splits[1]) {
                            if ( props.roundUp ) {
                                const numValue = splits.join('.').replace(/,/g, '')
                                let rounded_val = Math.round(parseFloat(numValue, 10))
                                const formatter = new Intl.NumberFormat('en-US');

                                return formatter.format(rounded_val);
                            } else {
                                // Has decimals, force to two places
                                const formatter = new Intl.NumberFormat('en-US', {
                                    maximumFractionDigits: 2,
                                    minimumFractionDigits: 2
                                });

                                return formatter.format(value);
                            }
                        }  else {
                            // No decimals, treat as an integer
                            const formatter = new Intl.NumberFormat('en-US');

                            return formatter.format(value);
                        }
                    }
                    case 'multiples': {
                        if (value === '') {
                            return value;
                        }
                        
                        const splits = value.toString().split('.');
                        
                        if (splits[1]) {
                                // Has decimals, force to two places
                                const formatter = new Intl.NumberFormat('en-US', {
                                    maximumFractionDigits: 2,
                                    minimumFractionDigits: 2
                                });

                                return formatter.format(value);

                        }  else {
                            // No decimals, treat as an integer
                            const formatter = new Intl.NumberFormat('en-US');

                            return formatter.format(value);
                        }
                    }
                    case 'hundredth': {
                        if (value === '') {
                            return value;
                        }

                        const formatter = new Intl.NumberFormat('en-US', {
                            maximumFractionDigits: 2,
                            minimumFractionDigits: 2
                        });

                        return formatter.format(value);
                    }
                    case 'percent': {
                        if (value === '') {
                            return value;
                        }

                        const splits = value.toString().indexOf('.') !== -1 ? value.toString().split('.') : false;
                        
                        if (splits[1]) {
                            if ( props.roundUp ) {
                                const numValue = splits.join('.').replace(/,/g, '')
                                let rounded_val = Math.round(parseFloat(numValue, 10))

                                // const formatter = new Intl.NumberFormat('en-US', {
                                //         maximumFractionDigits: 2,
                                //         minimumFractionDigits: 2
                                // });
                                const formatter = new Intl.NumberFormat('en-US');

                                return formatter.format(rounded_val);
                            } else {
                                const formatter = new Intl.NumberFormat('en-US', {
                                        maximumFractionDigits: 2,
                                        minimumFractionDigits: 2
                                });

                                return formatter.format(value);
                            }
                        }  else {
                            // No decimals, treat as an integer
                            const formatter = new Intl.NumberFormat('en-US');

                            return formatter.format(value);
                        }
                    }
                    case 'decimal': {
                        if (value === '') {
                            return value;
                        }

                        const formatter = new Intl.NumberFormat('en-US', {
                            maximumFractionDigits: 2,
                        });

                        return formatter.format(value);
                    }
                    case 'number': {
                        if (value === '') {
                            return value;
                        }

                        const splits = value.toString().split('.');
                        
                        if (splits[1]) {
                            if ( props.roundUp ) {
                                const numValue = splits.join('.').replace(/,/g, '')
                                let rounded_val = Math.round(parseFloat(numValue, 10))

                                const formatter = new Intl.NumberFormat('en-US', {
                                        maximumFractionDigits: 2,
                                        minimumFractionDigits: 2
                                });
                                
                                return formatter.format(rounded_val);
                            } else {
                                const formatter = new Intl.NumberFormat('en-US', {
                                        maximumFractionDigits: 2,
                                        minimumFractionDigits: 2
                                });

                                return formatter.format(value);
                            }
                        }  else {
                            const formatter = new Intl.NumberFormat('en-US');

                            return formatter.format(value);
                        }
                    }
                    case 'integer': {
                        if (value === '') {
                            return value;
                        }

                        const splits = value.toString().split('.');
                        
                        if (splits[1]) {
                            if ( props.roundUp ) {
                                const numValue = splits.join('.').replace(/,/g, '')
                                let rounded_val = Math.round(parseFloat(numValue, 10))

                                const formatter = new Intl.NumberFormat('en-US');
                                
                                return formatter.format(rounded_val);
                            } else {
                                const formatter = new Intl.NumberFormat('en-US', {
                                        maximumFractionDigits: 2,
                                        minimumFractionDigits: 2
                                });

                                return formatter.format(value);
                            }
                        }  else {
                            const formatter = new Intl.NumberFormat('en-US');

                            return formatter.format(value);
                        }
                    }
                    case 'year': {
                        if (value === '') {
                            return value;
                        }

                        let paddedNumber = String(value).padStart(4, '0');

                        return paddedNumber;
                    }
                    case 'url': {
                        let str
                        if (value.startsWith("http://") || value.startsWith("https://")) {
                            // str = this.urlCheck(value);
                            str = value
                            
                        } else {
                            // If it doesn't start with "http://" or "https://", add "http://"
                            // str = this.urlCheck("http://" + value);
                            str = `http://${value}`
                        }

                        return str
                    }
                    case 'format_date': {
                        if (!value) {
                            return null;
                        }

                        const [year, month, day] = value.split('-');

                        return `${month}/${day}/${year}`;
                    }
                }
                return value;
            },
            unFormatValue: function (val = '') {
                const { props } = this.item;
                const { format } = props;
                // console.log(typeof val)

                if (val === null || val === undefined) {
                    return undefined;
                }

                switch(format) {
                    case 'phone':
                    case 'ein':
                    case 'sos': {
                        // Strip any non-numerical characters
                        return val.replace(/[^0-9]/g, '');
                    }
                    case 'dollars':
                    case 'hundredth':
                    case 'number':
                    case 'percent': 
                    case 'decimal': {
                        // console.log(val)
                        // Strip commas
                        let numVal = val.replace(/,/g, '');
                        return Math.round(parseFloat(numVal, 10) * 100) / 100;
                    }
                }
                return val;
            },
            handleChange: function (val) {
                const isValid = this.validate();

                if (isValid) {
                    this.isFocus = false;
                    this.$emit('input', this.unFormatValue(val));
                }
            },
            handleFocus: function () {
                this.isFocus = true;
            },
            tabChange: function () {
                const { props } = this.item;
                const { tabKey } = props;

                if ( tabKey != undefined ) {
                    if ( tabKey.includes('http') ) {
                        window.open(tabKey, '_blank')
                    } else {
                        this.$emit('handleTabChange', tabKey)
                    }
                }
            },
            urlCheck: async function (url) {
                try {
                    const check_response = await axios.post(`${appUrls.api}/api/check_url`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                        url: url
                    })
                
                    // Check if the response status is in the range 200-299
                    return check_response.data.outcome ? url : 'Please enter a legitimate website address';

                } catch (error ) {
                    console.error('Error:', error);
                }
            },
            dateFormatting: function (dateString) {
                if (!dateString) {
                    return null;
                }

                const [year, month, day] = dateString.split('-');

                return `${month}/${day}/${year}`;
            }
        }
    }
</script>

<style scoped>
    .input-align-right >>> input {
        text-align: right;
    }
    /* .v-input__icon--append .v-icon { 
        color: purple;
    } */
</style>



// WEBPACK FOOTER //
// src/components/questionnaire_template/text-field.vue